import {ZodObject, ZodTypeAny} from 'zod';
import {ToolExecuteParams, ToolResult} from '../../copilot.types';

export default function tool<
  TInputSchema extends ZodTypeAny = ZodObject<Record<string, never>>,
  TAgentScratchpad = Record<string, unknown>,
>({
  name,
  displayName,
  description,
  inputSchema,
  execute,
}: {
  name: string;
  displayName: string;
  description: string;
  inputSchema: TInputSchema;
  execute: (params: ToolExecuteParams<TInputSchema, TAgentScratchpad>) => Promise<ToolResult>;
}) {
  return {
    name,
    displayName,
    description,
    execute,
    inputSchema,
  };
}
